import { render, staticRenderFns } from "./AppFooterMobile.vue?vue&type=template&id=30b973a6&scoped=true"
import script from "./AppFooterMobile.vue?vue&type=script&lang=js"
export * from "./AppFooterMobile.vue?vue&type=script&lang=js"
import style0 from "./AppFooterMobile.vue?vue&type=style&index=0&id=30b973a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b973a6",
  null
  
)

export default component.exports